// hooks/useWhatsappActivityListData.ts
import { getAiPeopleFlowWrongInfo } from '@api/services/analytics.service';
import useDataQuery from '@hooks/use-data-query';
import { useMemo } from 'react';

const useAiPeopleFlowListData = () => {
    const query = useDataQuery(['ai-people-flow'], () => getAiPeopleFlowWrongInfo());

    const data = useMemo(() => query.data || [], [query.data]);

    return {
        data,
        isLoading: query.isLoading,
    };
};

export default useAiPeopleFlowListData;
